// src/pages/About.jsx
import React from 'react';

function About() {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-md mb-8">
        {/* Top border accent with gradient */}
        <div className="h-1 bg-gradient-to-r from-slate-400 to-gray-500"></div>
        
        <div className="px-6 pt-6 pb-4">
          <h1 className="text-2xl font-semibold text-gray-900 mb-4">Contact</h1>
          
          <div className="space-y-4 text-gray-700">
            <p>
              If you would like to contact me, please email <a href="mailto:contact@cultoftheredhat.com" className="text-slate-600 hover:text-slate-800 underline">contact@cultoftheredhat.com</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;